import * as React from "react";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../components/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import FeedbackAndSupport from "./FeedbackAndSupport";

const App: React.FC = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute authenticatedElement={<FeedbackAndSupport />} isPopup={true} />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
